import React from "react";
import styled from "styled-components";
import { Switch } from "antd";

// width: ${(props) =>
//   props.size === "large" ? "60px" : "40px"};
// height: ${(props) =>
//   props.size === "large" ? "33px" : "22px"};

// .ant-switch-handle {
//   width: ${(props) => (props.size === "large" ? "26px" : "18px")};
//   height: ${(props) => (props.size === "large" ? "28px" : "18px")};
// }
const StyledSwitch = styled(Switch)`
  &.ant-switch {
    background-color: #ccc; /* Default background color when unchecked */

    &:hover {
      // background-color: #32b37b;
    }

    &.ant-switch-checked {
      background-color: #46d993; /* Background color when checked */

      &:hover {
        background-color: #32b37b; /* Hover color when checked */
      }
    }

    .ant-switch-handle {
      border-radius: 50%;
    }
  }
`;

export default StyledSwitch;
